export default __webpack_public_path__ + "static/media/mit.1e4c09b0.webp";